import { GroupWithId } from "../interfaces/IGroups";
import { ParticipantWithId } from "../interfaces/IParticipants";
import { useMemo, useState } from "react";

/**
 * Hook do wyszukiwania grup
 * Wyszukuje po nazwie grupy i zawodnikach w grupie
 */
export const useGroupsSearch = (
  groups: GroupWithId[],
  participants: ParticipantWithId[]
) => {
  const [searchTerm, setSearchTerm] = useState("");

  // Filtrowanie grup na podstawie wyszukiwania
  const filteredGroups = useMemo(() => {
    if (!searchTerm.trim()) {
      return groups;
    }

    const term = searchTerm.toLowerCase().trim();

    return groups.filter((group) => {
      // Wyszukiwanie po nazwie grupy
      const groupName = group.name?.toLowerCase() || "";
      if (groupName.includes(term)) {
        return true;
      }

      // Wyszukiwanie po zawodnikach w grupie
      const groupParticipants = participants.filter((p) =>
        group.participantIds.includes(p.id || "")
      );

      const hasMatchingParticipant = groupParticipants.some((participant) => {
        const firstName = participant.firstName?.toLowerCase() || "";
        const lastName = participant.lastName?.toLowerCase() || "";
        return firstName.includes(term) || lastName.includes(term);
      });

      return hasMatchingParticipant;
    });
  }, [groups, participants, searchTerm]);

  return {
    searchTerm,
    setSearchTerm,
    filteredGroups,
  };
};

